import { useEffect, useRef } from 'react';
import { useCheckoutSelector } from '../../reducers/root';
import { trackSummaryToggle } from '../../helpers/checkoutTracking';

export function useMobileSummaryTracking({ isReady }: { isReady: boolean }): void {
    const isSummaryOpen = useCheckoutSelector(state => state.pane.isSummaryOpen);
    const currentStep = useCheckoutSelector(state => state.pane.currentPane);
    const hasInitialTrackingFired = useRef(false);

    useEffect(() => {
        if (isReady && !hasInitialTrackingFired.current) {
            // make sure the tracking fires on initial load if it's opened by default
            if (isSummaryOpen) {
                trackSummaryToggle(isSummaryOpen, currentStep);
            }
            hasInitialTrackingFired.current = true;
        }
    }, [isReady, isSummaryOpen, currentStep]);
}
